module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits XL tyg orinocco grey detalj 2023 1.5d1637f2.jpg";